import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { Router } from '@angular/router';

@Component({
  selector: 'pps-signout-redirect-callback',
  template: "<div></div>",
  styles: []
})
export class SignoutRedirectCallbackComponent implements OnInit {
  constructor(
    private authService: AuthenticationService
  ) { }

  ngOnInit(): void {
    this.authService.completeLogout()
      .then(_ => {
        window.location.href = "/index.html";
      })
  }
}
